export default __webpack_public_path__ + "static/link-bg-eeaf894dc1db43ab784d3ace8c3219c3.jpg";